import script from "./UserReferralSISModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./UserReferralSISModal.vue?vue&type=script&setup=true&lang=ts"

import "./UserReferralSISModal.vue?vue&type=style&index=0&id=0f3bede8&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0f3bede8"]])

export default __exports__